module.exports = __webpack_public_path__ + "img/img_banner_size04.d0d80de2.svg";